import ReportList from '@components/common/ReportList';
import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { useFetchTeamMembers, useSingleSurvey } from '@hooks/getQueries';
import { useUserPermission } from '@hooks/userPermission';
import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

export default function SurveyReport() {
  const { id } = useParams();
  const { data: survey } = useSingleSurvey(id);
  const { data: teamMembers } = useFetchTeamMembers({
    studyId: id,
    studyUrlType: 'dynamic-surveys',
  });
  const { canEdit } = useUserPermission({
    entity: survey,
    teamMembers: teamMembers,
  });

  return (
    <PageContainer title={'Survey | Reports'}>
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary>
          <ReportList studyType="dynamic_survey" canManageReport={canEdit} />
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
